// src/pages/gears/DjiPocket.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import djipocket from "./gearimages/djipocket.jpg";
import djipocket2 from "./gearimages/djipocket2.jpg";

export default function DJIPocket2() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>DJI Pocket 2</h1>

              <p>
                The DJI Pocket 2 is one of the most portable stabilized cameras ever made.
                With its built‑in 3‑axis gimbal, 4K video, and upgraded 1/1.7” sensor,
                it delivers smooth, cinematic footage straight out of your pocket.
                It’s perfect for travel, vlogging, family moments, and capturing
                stabilized video without carrying a full camera setup.
              </p>

              <p>
                The Pocket 2 also includes improved audio with DJI Matrix Stereo,
                a wider lens for better framing, and intelligent shooting modes like
                ActiveTrack 3.0, Timelapse, Motionlapse, and Panorama.
                Whether you're walking, hiking, or filming handheld shots,
                the Pocket 2 keeps everything stable and sharp.
              </p>

              <div className="place-block">
                <ul>
                  <li>4K video at 60fps + 1080p at 240fps</li>
                  <li>1/1.7” sensor for improved low‑light performance</li>
                  <li>3‑axis mechanical gimbal stabilization</li>
                  <li>64MP photo mode (high‑resolution)</li>
                  <li>DJI Matrix Stereo audio system</li>
                  <li>ActiveTrack 3.0 subject tracking</li>
                  <li>HDR video (select modes)</li>
                  <li>Wide‑angle 93° FOV lens</li>
                  <li>Timelapse, Motionlapse & Hyperlapse modes</li>
                </ul>
              </div>

              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/3QkbP70"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/4cPRpc"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={djipocket} alt="DJI Pocket 2" />
              <img src={djipocket2} alt="DJI Pocket 2" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
